import fetcher from '../fetcher';

export type MasterGroup = {
	id: string;
	name: string;
	isActive: boolean;
	createdBy: string;
	createdDate: string;
	modifiedBy?: null;
	modifiedDate: string;
};

export type MasterGroupPayload = {
	name: string;
	isActive: boolean;
};

export const getMasterGroups = () => {
	return fetcher<MasterGroup[]>({
		api: '/mastergroups/get-all-master-group',
	});
};

export const getMasterGroup = (id: string) => {
	return fetcher<MasterGroup>({
		api: '/mastergroups/get-master-group',
		body: {
			id,
		},
	});
};

export const createMasterGroup = (payload: MasterGroupPayload) => {
	return fetcher<string>({
		api: '/mastergroups/create-master-group',
		body: payload,
	});
};

export const updateMasterGroup = (id: string, payload: MasterGroupPayload) => {
	return fetcher<string>({
		api: '/mastergroups/update-master-group',
		body: {
			id,
			...payload,
		},
	});
};
